import { basicEnum } from "./base";

export const CustomerCategoryEnum = basicEnum([
    {
        label: "Usaha Kecil Menengah / Industri Kecil Menengah",
        value: "umkm",
    },
    {
        label: "Perumahan / Apartemen / Kos",
        value: "home",
    },
    {
        label: "Hotel / Losmen / Homestay",
        value: "hotel",
    },
    {
        label: "Perkantoran",
        value: "office",
    },
    {
        label: "Industri Besar / Pabrik",
        value: "factory",
    },
    {
        label: "Warnet / Gamenet",
        value: "netcafe",
    },
    {
        label: "Cafe / Wisata / Publik Area Lain",
        value: "cafe",
    },
    {
        label: "Pertokoan / Usaha Mikro",
        value: "shops",
    },
    {
        label: "Lainnya",
        value: "other",
    },
]);

export namespace CustomerCategoryEnum {
    export type Labels = (typeof CustomerCategoryEnum)["labels"][number];
    export type Values = (typeof CustomerCategoryEnum)["values"][number];
}
